import { Table } from 'dexie';
import db, { DataRepository, Database, Key } from '@/db';
import { Setting } from '../../api/models';

export type TABLE_TYPE = Table<Setting>;

export const TABLE = 'setting';
const SCHEMA = 'settingId, sortId';

class SettingDatabase implements DataRepository<Setting> {
  constructor(private db: Database) {
    db.registerModelSchema(TABLE, SCHEMA);
  }

  get(key: Key): Promise<Setting | undefined> {
    return this.db[TABLE].get(key);
  }

  delete(key: Key): Promise<void> {
    return this.db[TABLE].delete(key);
  }

  update(payload: Setting, key: Key): Promise<Setting> {
    return this.db[TABLE].put(payload, key);
  }

  async bulkAdd(payload: Setting[]): Promise<Setting[]> {
    await this.db[TABLE].clear();
    return this.db[TABLE].bulkPut(payload);
  }

  list(): Promise<Setting[]> {
    return this.db[TABLE].orderBy('sortId').toArray();
  }
}

export const SettingDB = new SettingDatabase(db);
